// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Course from "./course.js"
import SchoolClass from "./school-class.js"
import SchoolClassCourseModule from "./school-class-course-module.js"

const modelClassData = {
  "attributes": {
    "course_id": {
      "column": {
        "default": null,
        "name": "course_id",
        "null": false,
        "type": null
      },
      "name": "course_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "locale": {
      "column": {
        "default": null,
        "name": "locale",
        "null": true,
        "type": "string"
      },
      "name": "locale",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_check_in_id": {
      "column": {
        "default": null,
        "name": "school_class_check_in_id",
        "null": true,
        "type": null
      },
      "name": "school_class_check_in_id",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_course_modules_count": {
      "column": {
        "default": "0",
        "name": "school_class_course_modules_count",
        "null": false,
        "type": "integer"
      },
      "name": "school_class_course_modules_count",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_id": {
      "column": {
        "default": null,
        "name": "school_class_id",
        "null": false,
        "type": null
      },
      "name": "school_class_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolClassCourse",
  "collectionKey": "school_class_courses",
  "collectionName": "school_class_courses",
  "i18nKey": "school_class_course",
  "camelizedLower": "schoolClassCourse",
  "name": "SchoolClassCourse",
  "nameDasherized": "school-class-course",
  "pluralName": "school_class_courses",
  "ransackable_associations": [
    {
      "className": "SchoolClassCourse::Audit",
      "collectionName": "school_class_course_audits",
      "foreignKey": "school_class_course_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseAudit",
      "through": null
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "SchoolClassCourse::Audit",
      "collectionName": "school_class_course_audits",
      "foreignKey": "school_class_course_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassCourseAudit",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "SchoolClassCourseModule",
      "collectionName": "school_class_course_modules",
      "foreignKey": "school_class_course_id",
      "name": "school_class_course_modules",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseModule",
      "through": null
    },
    {
      "className": "SchoolClassCourseScoreFactorGroupCache",
      "collectionName": null,
      "foreignKey": "school_class_course_id",
      "name": "score_factor_group_caches",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_id",
      "column": {
        "default": null,
        "name": "course_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "locale",
      "column": {
        "default": null,
        "name": "locale",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "school_class_check_in_id",
      "column": {
        "default": null,
        "name": "school_class_check_in_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "school_class_course_modules_count",
      "column": {
        "default": "0",
        "name": "school_class_course_modules_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "school_class_id",
      "column": {
        "default": null,
        "name": "school_class_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "team_id",
      "column": {
        "default": null,
        "name": "team_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "SchoolClassCourseModule",
      "collectionName": "school_class_course_modules",
      "foreignKey": "school_class_course_id",
      "name": "school_class_course_modules",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseModule",
      "through": null
    }
  ],
  "paramKey": "school_class_course",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassCourse. */
export default class SchoolClassCourse extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  courseId() {
    return this.readAttributeUnderscore("course_id")
  }

  /** @returns {boolean} */
  hasCourseId() {
    const value = this.courseId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  locale() {
    return this.readAttributeUnderscore("locale")
  }

  /** @returns {boolean} */
  hasLocale() {
    const value = this.locale()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  schoolClassCheckInId() {
    return this.readAttributeUnderscore("school_class_check_in_id")
  }

  /** @returns {boolean} */
  hasSchoolClassCheckInId() {
    const value = this.schoolClassCheckInId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  schoolClassCourseModulesCount() {
    return this.readAttributeUnderscore("school_class_course_modules_count")
  }

  /** @returns {boolean} */
  hasSchoolClassCourseModulesCount() {
    const value = this.schoolClassCourseModulesCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  schoolClassId() {
    return this.readAttributeUnderscore("school_class_id")
  }

  /** @returns {boolean} */
  hasSchoolClassId() {
    const value = this.schoolClassId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  startModule(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "start_module",
        primaryKey: this.primaryKey(),
        collectionName: "school_class_courses",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./course.js").default | null} */
  course() {
    return this._readBelongsToReflection({modelClass: Course, reflectionName: "course"})
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  loadCourse() {
    if (!("courseId" in this)) throw new Error("Foreign key method wasn't defined: courseId")

    const id = this.courseId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "course",
        model: this,
        modelClass: Course
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  ensureCourseLoaded() {
    return this.ensureAssociationLoaded("course")
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readBelongsToReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("schoolClassId" in this)) throw new Error("Foreign key method wasn't defined: schoolClassId")

    const id = this.schoolClassId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  ensureSchoolClassLoaded() {
    return this.ensureAssociationLoaded("school_class")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-course-module.js").default>} */
  schoolClassCourseModules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_class_course_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_course_modules",
        model: this,
        modelClass: SchoolClassCourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-course-module.js").default>>} */
  loadSchoolClassCourseModules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_class_course_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_course_modules",
        model: this,
        modelClass: SchoolClassCourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-course-module.js").default>>} */
  ensureSchoolClassCourseModulesLoaded() {
    return this.ensureAssociationLoaded("school_class_course_modules")
  }
}
